import { PageHero } from "@/components/layout/PageHero";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: "When you submit an enquiry through our website, we collect the details you provide: your name, company name, phone number, email address, the service you are interested in, your location, and your message. We do not collect payment information or sensitive personal data through this website.",
  },
  {
    title: "2. How We Use Your Information",
    body: "The information you submit is used solely to respond to your enquiry, prepare quotations, coordinate requested services, and maintain our business relationship with you. We may contact you by phone, WhatsApp, or email using the details you provide.",
  },
  {
    title: "3. Data Storage and Security",
    body: "Enquiries are stored securely in our systems with access restricted to authorized personnel only. We apply appropriate technical and organizational measures to protect your information against unauthorized access, loss, or misuse.",
  },
  {
    title: "4. Sharing of Information",
    body: "We do not sell, rent, or trade your personal information to third parties. Information may be shared with service partners only where necessary to fulfil a service you have requested, and always under confidentiality expectations.",
  },
  {
    title: "5. Cookies and Analytics",
    body: "This website may use basic analytics to understand how visitors use our pages and to improve the experience. No personally identifying tracking is performed without your knowledge.",
  },
  {
    title: "6. Your Rights",
    body: "You may request access to, correction of, or deletion of the personal information we hold about you at any time by contacting us using the details on our Contact page.",
  },
  {
    title: "7. Updates to This Policy",
    body: "We may update this Privacy Policy from time to time. The latest version will always be available on this page.",
  },
  {
    title: "8. Contact",
    body: "For any questions about this Privacy Policy or how your data is handled, please contact SIREE SOLUTIONS GROUPS (SSS GROUPS) through our Contact page.",
  },
];

const PrivacyPage = () => (
  <div data-testid="privacy-page">
    <PageHero
      eyebrow="Legal"
      title="Privacy Policy"
      description="How SIREE SOLUTIONS GROUPS collects, uses, and protects the information you share with us."
    />
    <section className="bg-white py-20">
      <div className="mx-auto max-w-3xl space-y-10 px-6 lg:px-10">
        <p className="text-sm text-slate-500">Last updated: January 2026</p>
        {SECTIONS.map((s) => (
          <div key={s.title}>
            <h2 className="font-serif text-xl font-bold text-navy-900">{s.title}</h2>
            <p className="mt-3 leading-relaxed text-slate-600">{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default PrivacyPage;
